import BaseModel from "../../../core/components/input-widget/BaseModel";
import {uuid} from "vue-uuid";

export default class InvoiceBatchPaymentItemModel extends BaseModel {
  uuid = null;
  invoice_uuid = null;
  invoice = null;
  amount = null;
  reference_number = null;
  reconciled = false;
  initial_amount = null;
  converted_amount = null;
  uniqueKey = uuid.v4();

  static TRANSLATABLE_FIELDS = [];

  rules = {
    invoice_uuid: 'required',
    amount: 'required|min_value:0.1',
  };

  attributeLabels = {
  };

  attributeHints = {
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initial_amount = this.amount
  }
}
